module.exports = global["paulsClock"] = require("-!/home/dev/repo/supporttrack_stng/root/static/assets/node_modules/babel-loader/index.js!/home/dev/repo/supporttrack_stng/root/static/assets/js/app/common/paulsclock.js");


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/common/paulsclock.js
 ** module id = 1216
 ** module chunks = 10
 **/